import FlightLog from "./Content/Flights/FlightLog";
import FlightProcess from "./Content/Flights/FlightProcess";
import FlightViewer from "./Content/Flights/FlightViewer";

import { guidRegex } from "../utilities/regex";
import { ApplicationArea } from "./Lumber/ApplicationAreas";

//-- enabled has no effect if the parent module (i.e. the module refrencing these routs in routs.js), is disabled
//--  That is, the enabled property cannot override the parent module enabled property if it is disabled

export const flightRoutes = [
	{
		id: "flight-log",
		name: "log",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Log",
		pageTitle: "Flight Log",
		icon: "search",
		cornerIcon: null,
		showInNav: true,
		secured: true,
		paths: [`/flights`, `/flights/log`],
		exact: true,
		component: FlightLog,
		module: "flights",
		applicationAreas: [ApplicationArea.FlightSearch],
		requiresContext: false,
		showModuleIdInBreadcrumb: false,
	},
	{
		id: "flight-new",
		name: "new",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "New",
		pageTitle: "Create New Flight",
		icon: "plus",
		cornerIcon: null,
		showInNav: true,
		secured: true,
		paths: [`/flights/new`],
		exact: true,
		component: () => FlightProcess({ activeStep: "info", mode: "new" }),
		module: "flights",
		applicationAreas: [ApplicationArea.FlightNew, ApplicationArea.FlightNewNoDelete],
		requiresContext: false,
		showModuleIdInBreadcrumb: false,
	},
	{
		id: "flight-info",
		navMatchingNames: ["info", "ortho-upload", "align-fields", "add-new-fields"],
		name: "info",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Edit",
		pageTitle: "Edit Flight",
		icon: "pencil",
		cornerIcon: null,
		showInNav: true,
		secured: true,
		paths: [`/flights/:id${guidRegex}?/info`],
		exact: true,
		component: () => FlightProcess({ activeStep: "info", mode: "edit" }),
		module: "flights",
		applicationAreas: [
			ApplicationArea.FlightInfo,
			ApplicationArea.FlightInfoNoDelete,
			ApplicationArea.FlightEdit,
			ApplicationArea.FlightEditNoDelete,
		],
		requiresContext: true,
		showModuleIdInBreadcrumb: false,
	},
	{
		id: "flight-ortho-upload",
		navMatchingNames: ["info", "ortho-upload", "align-fields", "add-new-fields"],
		name: "ortho-upload",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Ortho Upload",
		pageTitle: "Flight Ortho Upload",
		icon: "picture",
		cornerIcon: null,
		showInNav: false,
		secured: true,
		paths: [`/flights/:id${guidRegex}/ortho-upload`],
		exact: true,
		component: () => FlightProcess({ activeStep: "orthoUpload" }),
		module: "flights",
		applicationAreas: [
			ApplicationArea.FlightOrthoUpload,
			ApplicationArea.FlightOrthoUploadNoDelete,
			ApplicationArea.FlightGenerateOrtho,
			ApplicationArea.FlightDownloadOrtho,
			ApplicationArea.FlightOrthoFileshare,
		],
		requiresContext: true,
	},
	{
		id: "flight-align-fields",
		navMatchingNames: ["info", "ortho-upload", "align-fields", "add-new-fields"],
		name: "align-fields",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Align Fields",
		pageTitle: "Align Fields on Flight",
		icon: null,
		cornerIcon: null,
		showInNav: false,
		secured: true,
		paths: [`/flights/:id${guidRegex}/align-fields`],
		exact: true,
		component: () => FlightProcess({ activeStep: "alignFields" }),
		module: "flights",
		applicationAreas: [ApplicationArea.FlightAlignFields],
		requiresContext: true,
	},
	{
		id: "flight-add-new-fields",
		name: "add-new-fields",
		navMatchingNames: ["info", "ortho-upload", "align-fields", "add-new-fields"],
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Add New Fields",
		pageTitle: "Add New Fields to Flight",
		icon: null,
		cornerIcon: null,
		showInNav: false,
		secured: true,
		paths: [`/flights/:id${guidRegex}/add-new-fields`],
		exact: true,
		component: () => FlightProcess({ activeStep: "addNewFields" }),
		module: "flights",
		applicationAreas: [ApplicationArea.FlightAddNewFields],
		requiresContext: true,
	},
	{
		id: "flight-plot-analysis",
		name: "plot-analysis",
		navMatchingNames: [],
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Analysis",
		pageTitle: "Plot Analysis",
		icon: "chart bar outline",
		cornerIcon: null,
		showInNav: true,
		secured: true,
		paths: [`/flights/:id${guidRegex}/plot-analysis`],
		exact: true,
		component: () => FlightProcess({ activeStep: "plotAnalysis" }),
		module: "flights",
		applicationAreas: [ApplicationArea.FlightPlotAnalysis, ApplicationArea.FlightPlotAnalysisCRUD],
		requiresContext: true,
	},
	{
		id: "flight-viewer",
		name: "viewer",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Viewer",
		pageTitle: "Flight Viewer",
		icon: "binoculars",
		cornerIcon: null,
		showInNav: true,
		secured: true,
		paths: [`/flights/:id${guidRegex}`, `/flights/:id${guidRegex}/viewer`],
		exact: true,
		component: FlightViewer,
		module: "flights",
		applicationAreas: [ApplicationArea.FlightViewer],
		requiresContext: true,
	},
	// vector data layer navigation (hijacked onto flights routes for now)
	{
		id: "flight-vector-data-layer-upload",
		navMatchingNames: ["info", "vector-data-layer-upload"],
		name: "vector-data-layer-upload",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Data Layer Upload",
		pageTitle: "Data Layer Upload",
		icon: "map outline",
		cornerIcon: null,
		showInNav: false,
		secured: true,
		paths: [`/flights/:id${guidRegex}/data-layer-upload`],
		exact: true,
		component: () => FlightProcess({ activeStep: "vectorDataLayerUpload" }),
		module: "flights",
		applicationAreas: [ApplicationArea.DataLayerWizardCRUD],
		requiresContext: true,
	},
	{
		id: "flight-vector-data-layer-assoc-fields",
		navMatchingNames: ["info", "data-layer-upload", "data-layer-assoc-fields"],
		name: "vector-data-layer-assoc-fields",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Data Layer Field Association",
		pageTitle: "Field Association",
		icon: "map outline",
		cornerIcon: null,
		showInNav: false,
		secured: true,
		paths: [`/flights/:id${guidRegex}/data-layer-assoc-fields`],
		exact: true,
		component: () => FlightProcess({ activeStep: "vectorDataLayerFieldAssoc" }),
		module: "flights",
		applicationAreas: [ApplicationArea.DataLayerWizardCRUD],
		requiresContext: true,
	},
	{
		id: "flight-vector-data-layer-plot-results",
		navMatchingNames: ["data-layer-plot-results"],
		name: "vector-data-layer-plot-results",
		enabled: true,
		login: false,
		logout: false,
		home: false,
		linkText: "Vector Data Layer Plot Results",
		pageTitle: "Plot Results",
		icon: "map outline",
		cornerIcon: null,
		showInNav: false,
		secured: true,
		paths: [`/flights/:id${guidRegex}/data-layer-plot-results`],
		exact: true,
		component: () => FlightProcess({ activeStep: "vectorDataLayerPlotResults" }),
		module: "flights",
		applicationAreas: [ApplicationArea.DataLayerWizardCRUD, ApplicationArea.DataLayerWizard],
		requiresContext: true,
	},
];

export default {
	flightRoutes,
};
